import { Component, OnInit, Input } from '@angular/core';
import { AuthApiService } from 'app/core/api/auth-api.service';
import { config } from 'app/shared/smartadmin.config';

@Component({
  selector: '[activitiesMessage]',
  templateUrl: './activities-message.component.html',
})
export class ActivitiesMessageComponent implements OnInit {

  @Input() item: any;

  isAdmin = false;
  isTorre = false;
  isGerencia = false;
  isRefacciones = false;
  myClass = 'label-default';

  constructor(private authService: AuthApiService) {

  }

  ngOnInit() {
    this.isAdmin = this.authService.GetRolEnabled(config.roles.admin);
    this.isTorre = this.authService.GetRolEnabled(config.roles.torre);
    this.isGerencia = this.authService.GetRolEnabled(config.roles.gerencia);
    this.isRefacciones = this.authService.GetRolEnabled(config.roles.refacciones);



  }

  GetClass() {
    let myClass = 'label-default';

    if (this.item && this.item.cantidad > 0) {
      switch (this.item.clave) {
        case 'REC':
        case 'VAL':
        case 'AUT':
        case 'REP':
        case 'TER':
        case 'ENT':
          if (this.isAdmin || this.isTorre || this.isGerencia) {
            myClass = 'label-danger';
          }
          break;

        case 'COT':
          if (this.isAdmin || this.isRefacciones || this.isGerencia) {
            myClass = 'label-danger';
          }
          break;

        case 'PRE':
        case 'PLA':
          if (this.isAdmin || this.isGerencia) {
            myClass = 'label-danger';
          }
          break;

      }
    }

    return myClass;
  }

}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/layout/header/activities/activities-message/activities-message.component.ts